module.exports = __webpack_public_path__ + "static/media/wallet-illustration.0965bb8c.png";